<template>
  <div>
    <div v-if="loading" class="text-center py-4 text-muted">
      <i class="fe fe-loader" style="font-size:1.5rem; opacity:0.4;"></i>
      <p class="mt-2 mb-0 small">Loading diagnoses data…</p>
    </div>
    <div v-else-if="!series[0].data.length" class="text-center py-4 text-muted">
      <i class="fe fe-inbox" style="font-size:2rem; opacity:0.3;"></i>
      <p class="mt-2 mb-0 small">No diagnoses data. Click Refresh to load.</p>
    </div>
    <apexchart v-else type="bar" :height="height" :options="chartOptions" :series="series" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

function chartToolbar(filename) {
  return {
    show: true,
    tools: { download: true, selection: false, zoom: false, zoomin: false, zoomout: false, pan: false, reset: false },
    export: { csv: { filename: filename }, svg: { filename: filename }, png: { filename: filename } },
  };
}

export default {
  components: { apexchart: VueApexCharts },
  props: {
    categories: { type: Array,            default: function () { return []; } },
    series:     { type: Array,            default: function () { return [{ name: "Claims", data: [] }]; } },
    loading:    { type: Boolean,          default: false },
    height:     { type: [Number, String], default: 380 },
    filename:   { type: String,           default: "claims-top-diagnoses" },
  },
  computed: {
    chartOptions() {
      return {
        chart: { type: "bar", toolbar: chartToolbar(this.filename), fontFamily: "inherit" },
        plotOptions: { bar: { horizontal: true, borderRadius: 4, barHeight: "60%" } },
        dataLabels: { enabled: true },
        xaxis: {
          categories: this.categories,
          labels: { style: { fontSize: "11px", colors: "#64748b" } },
        },
        yaxis: {
          labels: { style: { fontSize: "11px", colors: "#64748b" }, maxWidth: 200 },
        },
        colors: ["#2563eb"],
        grid: { borderColor: "#f1f5f9", strokeDashArray: 4 },
        tooltip: { y: { formatter: function (v) { return v.toLocaleString() + " claims"; } } },
      };
    },
  },
};
</script>
